module.exports = __webpack_public_path__ + "img/MMIC_Invoice.cc339ba1.png";